import * as React from "react";
import {
    Calendar,
  CalendarProps,
} from "@progress/kendo-react-dateinputs";

export const CustomCalendar = (props: CalendarProps) => {
    const { navigation, ...others } = props;
  return <Calendar navigation={false} {...others} />;
};